module.exports = __webpack_public_path__ + "img/pay-value3.ca01c911.png";